export const SIDEBAR_LINKS = [
	{
		group: "Dashboards",
		links: [
			{
				name: "Website Analytics",
				url: "index.html",
				icon: "public",
			},
			{
				name: "E-Commerce",
				url: "e-commerce.html",
				icon: "shopping_bag",
				pro: true,
			},
		],
	},
	{
		group: "Application Views",
		links: [
			{
				name: "User",
				icon: "face",
				sub: [
					{
						name: "Timeline",
						url: "user-timeline.html",
						pro: true,
					},
					{
						name: "About",
						url: "user-about.html",
					},
					{
						name: "Pictures",
						url: "user-pictures.html",
					},
					{
						name: "Connections",
						url: "user-connections.html",
					},
					{
						name: "Preferences",
						url: "user-preferences.html",
					},
				],
			},
			{
				name: "File Manager",
				icon: "folder",
				url: "file-manager.html",
				pro: true,
			},
			{
				name: "Contacts",
				icon: "account_circle",
				url: "contacts.html",
				pro: true,
			},
			{
				name: "Mail",
				icon: "mail",
				url: "mail.html",
				pro: true,
			},
			{
				name: "Messages",
				icon: "mark_chat_unread",
				url: "messages.html",
				pro: true,
			},
			{
				name: "Photos",
				icon: "crop_original",
				url: "photos.html",
				pro: true,
			},
			{
				name: "Todo Lists",
				icon: "check_circle",
				url: "todo-lists.html",
				pro: true,
			},
			{
				name: "Calendar",
				icon: "calendar_today",
				url: "calendar.html",
				pro: true,
			},
			{
				name: "Issues Tracker",
				icon: "table_chart_view",
				url: "issues-tracker.html",
			},
		],
	},
	{
		group: "Miscellaneous",
		links: [
			{
				name: "Sample Pages",
				icon: "article",
				sub: [
					{
						name: "Invoice",
						url: "invoice.html",
					},
					{
						name: "Pricing Table",
						url: "pricing-table.html",
					},
					{
						name: "Search Results",
						url: "search-results.html",
						pro: true,
					},
					{
						name: "FAQ",
						url: "faq.html",
						pro: true,
					},
					{
						name: "Teams",
						url: "teams.html",
					},
					{
						name: "Login",
						url: "login.html",
					},
					{
						name: "Register",
						url: "register.html",
					},
					{
						name: "Forgot Password",
						url: "forgot-password.html",
					},
					{
						name: "Coming Soon",
						url: "coming-soon.html",
					},
					{
						name: "Error",
						url: "error.html",
					},
				],
			},
			{
				name: "Content",
				icon: "chrome_reader_mode",
				sub: [
					{
						name: "Typography",
						url: "typography.html",
					},
					{
						name: "Code",
						url: "code.html",
					},
					{
						name: "Images",
						url: "images.html",
					},
					{
						name: "Table",
						url: "tables.html",
					},
				],
			},
			{
				name: "Icons",
				icon: "sentiment_satisfied",
				url: "icons.html",
			},
			{
				name: "Forms",
				icon: "list_alt",
				sub: [
					{
						name: "Input Groups",
						url: "input-groups.html",
					},
					{
						name: "Form Elements",
						url: "form-elements.html",
					},
					{
						name: "Components",
						url: "form-components.html",
						pro: true,
					},
					{
						name: "Templates",
						url: "form-templates.html",
					},
					{
						name: "Validation",
						url: "form-validation.html",
					},
				],
			},
			{
				name: "Components",
				icon: "grid_view",
				sub: [
					{
						name: "Accordion",
						url: "accordion.html",
					},
					{
						name: "Alerts",
						url: "alerts.html",
					},
					{
						name: "Badges",
						url: "badges.html",
					},
					{
						name: "Buttons",
						url: "buttons.html",
					},
					{
						name: "Button Groups",
						url: "button-groups.html",
					},
					{
						name: "Cards",
						url: "cards.html",
					},
					{
						name: "Carousel",
						url: "carousel.html",
					},
					{
						name: "Collapse",
						url: "collapse.html",
					},
					{
						name: "Dropdown",
						url: "dropdown.html",
					},
					{
						name: "List Group",
						url: "list-group.html",
					},
					{
						name: "Modal",
						url: "modal.html",
					},
					{
						name: "Progress",
						url: "progress.html",
					},
					{
						name: "Spinners",
						url: "spinners.html",
					},
					{
						name: "Tabs",
						url: "tabs.html",
					},
					{
						name: "Tooltips",
						url: "tooltips.html",
					},
				],
			},
			{
				name: "Charts and Maps",
				icon: "analytics",
				sub: [
					{
						name: "Charts",
						url: "charts.html",
					},
					{
						name: "Maps",
						url: "maps.html",
					},
				],
			},
		],
	},
];
